import React, { useMemo, useCallback } from 'react';
import { KView, KText, KImage } from '@/component/RtlLayout';
import { styles } from '@/common/style';
import TextSwipper from '@/component/ScrollSwipper';
import { k18nPro } from './k18npro';
import { $k18n } from '@/common/i18n';
import { useShopInfoStore } from '../../store/shopInfoStore';
import { TouchableOpacity, Text, TouchableWithoutFeedback, StyleSheet, ImageStyle } from 'react-native';
import { debounce } from '@/common/utils/debounce';
import Image from '@kds/image';
import { Progress } from '@kibt/meta-ui-krn';
import MerchantBagIcon from '@/assets/image_mechant/merchant_bag_icon.png';
import IconArrowRed from '@/assets/icon/icon_arrow_right_red.png';
import { webCurrency } from '@/common/const';
import { vIf } from '@/common/utils/vIf';
import Flex from '@/component/atom/Flex';
import Button from '@/component/Button/Button';
import { getMyShoppingCarUrl } from '@/common/utils/buildUrl';
import { openUrl } from '@/common/bridge/openUrl';
import { logger } from '@/common/log';
import { LogShow } from '@/component/ViewVisible/ViewVisible';
import iconAddCart from '@/assets/images/cart.png';
import LinearGradient from 'react-native-linear-gradient';
import { useQuery } from '@/hooks/useQuery';

type IProps = Record<string, any>;

function logShowProductCoupon(isFinish, diff, couponId = '') {
    logger.sendShow({
        action: 'PRODUCT_COUPON',
        params: {
            coupon_id: couponId,
            difference_value: diff,
            is_finish: isFinish,
        },
    });
}

function logShowShippingCoupon(isFinish, diff, couponId = '') {
    logger.sendShow({
        action: 'FREIGHT_COUPON',
        params: {
            coupon_id: couponId,
            difference_value: diff,
            is_finish: isFinish,
        },
    });
}

// abnormalType: 0: 库存不足
const logShowProgress = ({
    ratio,
    abnormalType,
    currentStage,
    totalStage,
}: {
    ratio: number;
    abnormalType?: number;
    currentStage: number;
    totalStage: number;
}) => {
    logger.sendShow({
        action: 'PROGRESS_BAR',
        params: {
            ratio,
            abnormal_type: abnormalType,
            // 门槛数
            bought_together_stage_total: totalStage,
            // 正在凑第几个门槛
            bought_together_stage_in_progress: currentStage,
        },
    });
};

export function useExtraInfoObject() {
    const extraInfo = useQuery<string>('extra_info') || '{}';
    let extraInfoObj = {
        entrance_type: '',
    };
    try {
        if (extraInfo) {
            extraInfoObj = JSON.parse(extraInfo);
        }
    } catch (error) {
        console.log(error);
    }
    return extraInfoObj;
}

const style = StyleSheet.create({
    textRed: {
        color: 'rgba(255, 73, 6, 1)',
    },
    cardBox: {
        paddingLeft: 14,
        paddingVertical: 15,
        backgroundColor: '#fff',
    },
    iconRight: {
        width: 16,
        height: 16,
    },
});

export default function BottomNodeCom(props: IProps) {
    const {
        bottomNodeHeight,
        setVisiblePopCart,
        visiblePopCart,
        checkoutDetailPopupVisible,
        setCheckoutDetailPopupVisible,
        storeAddonStyle,
        ABmerchantAddonOptimize,
    } = props;

    // const { fetchStoreCartItem, loading: loadingGetStoreCartItem } = useGetStoreCartItem();

    // const { storeAddonStyle } = useShowCart({});

    const {
        shopInfo,
        tabIndex,
        setTabIndex,
        storeCartItem,
        salesList,
        tabsContent,
        setTabsContent,
        priceList,
        setPriceList,
        recoList,
        selectedInsufficient,
    } = useShopInfoStore((store) => {
        return {
            shopInfo: store.shopInfo,
            tabIndex: store.tabIndex,
            setTabIndex: store.setTabIndex,
            storeCartItem: store.storeCartItem,

            salesList: store.salesList,
            tabsContent: store.tabsContent,
            setTabsContent: store.setTabsContent,
            priceList: store.priceList,
            setPriceList: store.setPriceList,
            recoList: store.recoList,
            selectedInsufficient: store.selectedInsufficient,
        };
    });
    const shopDiscount = storeCartItem?.cartShopList[0]?.shopEvaluate?.shopDiscount;
    const productList = storeCartItem?.cartShopList[0]?.cartItemList || [];
    const selectedCartItems = productList.filter((v) => v.isSelected);

    // const {
    //     popupNode: checkoutDetailPopup,
    //     visible: checkoutDetailPopupVisible,
    //     setVisible: setCheckoutDetailPopupVisible,
    // } = useCheckoutDetailPopup({ shopCartItem: storeCartItem?.cartShopList[0] });

    const selectedCartItemList = useMemo(() => {
        return storeCartItem?.cartShopList[0]?.cartItemList.filter((item) => item.isSelected);
    }, [storeCartItem, storeCartItem?.cartShopList]);

    // const [visiblePopCart, setVisiblePopCart] = useState(false);

    const percentage = useMemo(() => {
        // 没选中
        const isNoSelected = selectedCartItemList?.length === 0;
        // 运费凑单券，运费只凑一张
        const {
            currentLevel: currentShippingCoupon,
            nextLevel: nextShippingCoupon,
            amountToNextLevel: shippingAmountToNextLevel,
        } = storeCartItem?.cartShopList[0]?.shopEvaluate?.shopEvaluateCoupon?.shippingMakeupCoupons || {};
        // 商品凑单券
        const {
            currentLevel: currentProductCoupon,
            nextLevel: nextProductCoupon,
            amountToNextLevel: productAmountToNextLevel,
        } = storeCartItem?.cartShopList[0]?.shopEvaluate?.shopEvaluateCoupon?.itemMakeupCoupons || {};
        // 没有券
        const noCoupon = !currentShippingCoupon && !nextShippingCoupon && !currentProductCoupon && !nextProductCoupon;
        // 已经凑够了运费券，就不再凑运费券了
        const nextShippingCouponThreshold = currentShippingCoupon ? Infinity : nextShippingCoupon?.threshold?.amount ?? Infinity;
        const nextProductCouponThreshold = nextProductCoupon?.threshold?.amount ?? Infinity;

        if (!isNoSelected && noCoupon && storeCartItem?.selectedAllMerchantFreeShip) {
            logShowProgress({
                ratio: 100,
                currentStage: 1,
                totalStage: 1,
            });
            return 100;
        }

        if (isNoSelected || noCoupon || selectedInsufficient) {
            logShowProgress({
                ratio: 0,
                abnormalType: selectedInsufficient ? 0 : undefined,
                currentStage: 0,
                totalStage: 1,
            });
            return 0;
        }

        // 有凑够的就显示100 @zhangyi
        // 没有更高的了，凑完了也显示100
        if (currentShippingCoupon || currentProductCoupon || (nextShippingCouponThreshold === Infinity && nextProductCouponThreshold === Infinity)) {
            logShowProgress({
                ratio: 100,
                currentStage: 1,
                totalStage: 1,
            });
            return 100;
        }

        if (nextProductCouponThreshold <= nextShippingCouponThreshold) {
            const percent = Math.floor(((nextProductCouponThreshold - productAmountToNextLevel.amount) / nextProductCouponThreshold) * 100);
            logShowProgress({
                ratio: percent,
                totalStage: 1,
                currentStage: percent === 100 ? 1 : 0,
            });
            return percent;
        }

        const percent = Math.floor(((nextShippingCouponThreshold - shippingAmountToNextLevel.amount) / nextShippingCouponThreshold) * 100);
        logShowProgress({
            ratio: percent,
            totalStage: 1,
            currentStage: percent === 100 ? 1 : 0,
        });
        return percent;
    }, [selectedCartItemList, storeCartItem]);

    const textStyle = {
        border: styles({
            color: '#000000',
            // fontWeight: '500',
        }),
        highLight: styles({
            color: '#ff4906',
            fontWeight: '500',
        }),
        highLight400: styles({
            color: '#ff4906',
            fontWeight: '500',
        }),
    };

    const getHighlightText = (displayAmount, bold = true) => {
        if (!bold) {
            return <Text style={textStyle.highLight400}>{displayAmount}</Text>;
        }
        return <Text style={textStyle.highLight}>{displayAmount}</Text>;
    };

    const getBoldText = (displayAmount) => {
        return <Text style={textStyle.border}>{displayAmount}</Text>;
    };
    const getFreeShippingText = () => $k18n('包邮');

    const getProductDiscountText = (discount) =>
        $k18n({
            text: '{discount} OFF',
            params: { discount },
        });
    const totalPriceNumber = useMemo(() => {
        if (selectedInsufficient) return 0;
        if (selectedCartItemList?.length === 0) return 0;

        return storeCartItem?.cartShopList[0].shopEvaluate?.shopDiscount?.itemCouponDiscount?.now?.amount ?? 0;
    }, [storeCartItem, storeCartItem?.cartShopList[0], selectedInsufficient, selectedCartItemList]);

    // prd: https://docs.corp.kuaishou.com/d/home/fcACWkb3Mpfi3HA9R7W9l7l1c#section=h.gw96jf8sln4r
    const discountText = useMemo(() => {
        // 如果未选中商品
        const isNoSelected = selectedCartItemList?.length === 0;
        // 运费凑单券，运费只凑一张
        let {
            currentLevel: currentShippingCoupon,
            nextLevel: nextShippingCoupon,
            amountToNextLevel: shippingAmountToNextLevel,
        } = storeCartItem?.cartShopList[0]?.shopEvaluate?.shopEvaluateCoupon?.shippingMakeupCoupons || {};
        // 商品凑单券
        let {
            currentLevel: currentProductCoupon,
            nextLevel: nextProductCoupon,
            amountToNextLevel: productAmountToNextLevel,
            moreDeductOfNextLevel: productMoreDeductOfNextLevel,
        } = storeCartItem?.cartShopList[0]?.shopEvaluate?.shopEvaluateCoupon?.itemMakeupCoupons || {};

        // 如果命中了强化实验，且完成全部凑单阶段，则不显示后面未凑的凑单优惠
        const { totalStage = 1, currentStage = 0, progress = 0 } = storeCartItem?.cartShopList[0]?.thresholdStage || {};

        // 没选中时，使用shopPromotion中的数据
        if (isNoSelected) {
            currentShippingCoupon = null;
            currentProductCoupon = null;

            // nextShippingCoupon = storeCartItem?.cartShopList[0]?.shopPromotion?.shippingAvailableCoupon;
            // nextProductCoupon = storeCartItem?.cartShopList[0]?.shopPromotion?.itemAvailableCoupon;
            // shippingAmountToNextLevel = storeCartItem?.cartShopList[0]?.shopPromotion?.shippingAvailableCoupon?.threshold;
            // productAmountToNextLevel = storeCartItem?.cartShopList[0]?.shopPromotion?.itemAvailableCoupon?.threshold;
            // productMoreDeductOfNextLevel = storeCartItem?.cartShopList[0]?.shopPromotion?.itemAvailableCoupon?.maxDeductAmount;

            const shopPromotion = storeCartItem?.cartShopList[0]?.shopPromotion;
            nextShippingCoupon = shopPromotion?.shippingAvailableCouponsList?.[0];
            nextProductCoupon = shopPromotion?.itemAvailableCouponsList?.[0];
            shippingAmountToNextLevel = nextShippingCoupon?.threshold;
            productAmountToNextLevel = nextProductCoupon?.threshold;
            productMoreDeductOfNextLevel = nextProductCoupon?.maxDeductAmount;
        } else if (storeCartItem?.selectedAllMerchantFreeShip) {
            // 全商家包邮时，后端不出运费券，但是需要展示包邮
            currentShippingCoupon = {
                threshold: {
                    amount: 0,
                },
            };
        } else if (ABmerchantAddonOptimize?.showProgressOptimize && currentStage === totalStage && progress === 100) {
            nextShippingCoupon = null;
            nextProductCoupon = null;
        }

        // 要凑的运费券是无门槛的
        const isNextShippingCouponNoThreshold = nextShippingCoupon && nextShippingCoupon.threshold.amount === 0;
        // 要凑的商品券是无门槛的
        const isNextProductCouponNoThreshold = nextProductCoupon && nextProductCoupon.threshold.amount === 0;
        // 都是无门槛的
        const isNextNoThreshold = isNextShippingCouponNoThreshold && isNextProductCouponNoThreshold;
        // 如果要凑的券门槛相同
        const isNextThresholdSame =
            nextShippingCoupon && nextProductCoupon && nextShippingCoupon.threshold.amount === nextProductCoupon.threshold.amount;
        // 产品希望高亮展示，所以把文案拆成单独的 @zhangyi

        // 当前购物车为空或者未选中商品，此时 current 一定都为空
        if (isNoSelected) {
            // 同时凑两张无门槛优惠券
            if (isNextNoThreshold) {
                logShowProductCoupon(false, 0);
                logShowShippingCoupon(false, 0);
                // 加购即可同时享包邮和Y优惠券
                return k18nPro({
                    text: '加购即享{free_shipping}和{X_OFF}',
                    params: {
                        free_shipping: getHighlightText(getFreeShippingText()),
                        X_OFF: getHighlightText(getProductDiscountText(nextProductCoupon.maxDeductAmount?.displayAmount)),
                    },
                });
            }

            if (isNextShippingCouponNoThreshold) {
                logShowShippingCoupon(false, 0);
                // 加购即享包邮
                return k18nPro({
                    text: '加购即享{benefits}',
                    params: { benefits: getHighlightText(getFreeShippingText()) },
                });
            }

            if (isNextProductCouponNoThreshold) {
                logShowProductCoupon(false, 0);
                // 加购即享xxx优惠券
                return k18nPro({
                    text: '加购即享{benefits}',
                    params: { benefits: getHighlightText(getProductDiscountText(nextProductCoupon.maxDeductAmount?.displayAmount)) },
                });
            }
        }

        // 一次凑两张，只有当前一张都没凑成才能凑两张，而且要凑的两张券的门槛相同
        if (!currentShippingCoupon && !currentProductCoupon && isNextThresholdSame) {
            logShowProductCoupon(false, productAmountToNextLevel?.amount);
            logShowShippingCoupon(false, shippingAmountToNextLevel?.amount);
            // 还差{num1}可同时享包邮和{num2}优惠券
            return k18nPro({
                id: 'k_380019',
                text: '再加{more_items}可享{free_shipping}和{X_OFF}',
                params: {
                    more_items: getBoldText(productAmountToNextLevel?.displayAmount),
                    free_shipping: getHighlightText(getFreeShippingText()),
                    X_OFF: getHighlightText(getProductDiscountText(productMoreDeductOfNextLevel?.displayAmount)),
                },
            });
        }

        // 已凑成运费券和一张低门槛商品券
        if (currentShippingCoupon && currentProductCoupon) {
            // 还有更高门槛的商品券
            if (nextProductCoupon) {
                logShowProductCoupon(false, productAmountToNextLevel?.amount);
                logShowShippingCoupon(true, 0, currentShippingCoupon.couponId);
                // 已享包邮和{num1}优惠券，再凑{num2}可享{num3}优惠券
                return k18nPro({
                    text: '已享{free_shipping}和{X_OFF}, 再加{more_items}可再享{benefits}',
                    params: {
                        free_shipping: getBoldText(getFreeShippingText()),
                        X_OFF: getBoldText(getProductDiscountText(currentProductCoupon.deductAmount?.displayAmount)),
                        more_items: getHighlightText(productAmountToNextLevel?.displayAmount),
                        benefits: getHighlightText(getProductDiscountText(productMoreDeductOfNextLevel?.displayAmount)),
                    },
                });
            }

            logShowProductCoupon(true, 0, currentProductCoupon.couponId);
            logShowShippingCoupon(true, 0, currentShippingCoupon.couponId);
            // 已享包邮和{num}优惠券
            return k18nPro({
                text: '已享{free_shipping}和{X_OFF}',
                params: {
                    free_shipping: getBoldText(getFreeShippingText()),
                    X_OFF: getBoldText(getProductDiscountText(currentProductCoupon.deductAmount?.displayAmount)),
                },
            });
        }

        // // 已凑成运费券
        if (currentShippingCoupon) {
            logShowShippingCoupon(true, 0, currentShippingCoupon.couponId);
            // 已享包邮
            let text = k18nPro({
                text: '已享{benefits}！',
                params: { benefits: getBoldText(getFreeShippingText()) },
            });

            // 如果有可以凑的商品券
            if (!currentProductCoupon && nextProductCoupon) {
                logShowProductCoupon(false, productAmountToNextLevel?.amount);
                // 还差xxx可享xxx优惠券
                text = (
                    <Text>
                        {text}
                        {k18nPro({
                            id: 'more_item_more_benefits',
                            text: '再加{more_items}可享{benefits}',
                            params: {
                                more_items: getBoldText(productAmountToNextLevel?.displayAmount),
                                benefits: getHighlightText(getProductDiscountText(productMoreDeductOfNextLevel?.displayAmount)),
                            },
                        })}
                    </Text>
                );
            }

            return text;
        }

        // 已经凑成商品券
        if (currentProductCoupon) {
            logShowProductCoupon(true, 0, currentProductCoupon.couponId);

            // 已享xxx优惠券
            let text = k18nPro({
                text: '已享{benefits}！',
                params: {
                    benefits: getBoldText(getProductDiscountText(currentProductCoupon.deductAmount?.displayAmount)),
                },
            });

            // 开始凑运费券
            if (
                !currentShippingCoupon &&
                nextShippingCoupon &&
                nextProductCoupon &&
                nextShippingCoupon.threshold.amount === nextProductCoupon?.threshold?.amount
            ) {
                logShowShippingCoupon(false, shippingAmountToNextLevel?.amount);
                // 还差X可享包邮
                <Text>
                    {text}
                    {k18nPro({
                        id: 'k_380019',
                        text: '再加{more_items}可再享{X_OFF}和{free_shipping}',
                        params: {
                            X_OFF: getHighlightText(getProductDiscountText(nextProductCoupon.maxDeductAmount?.displayAmount)),
                            more_items: getBoldText(shippingAmountToNextLevel?.displayAmount),
                            free_shipping: getHighlightText(getFreeShippingText()),
                        },
                    })}
                </Text>;
            } else if (
                !currentShippingCoupon &&
                nextShippingCoupon &&
                nextShippingCoupon.threshold.amount < (nextProductCoupon?.threshold?.amount ?? Infinity)
            ) {
                logShowShippingCoupon(false, shippingAmountToNextLevel?.amount);
                // 还差X可享包邮
                text = (
                    <Text>
                        {text}
                        {k18nPro({
                            text: '再加{more_items}可享{benefits}',
                            params: {
                                more_items: getBoldText(shippingAmountToNextLevel?.displayAmount),
                                benefits: getHighlightText(getFreeShippingText()),
                            },
                        })}
                    </Text>
                );
            } else if (nextProductCoupon && nextProductCoupon.threshold.amount < (nextShippingCoupon?.threshold?.amount ?? Infinity)) {
                text = (
                    <Text>
                        {text}
                        {k18nPro({
                            id: 'more_item_more_benefits',
                            text: '再加{more_items}可享{benefits}',
                            params: {
                                more_items: getBoldText(productAmountToNextLevel?.displayAmount),
                                benefits: getHighlightText(getProductDiscountText(productMoreDeductOfNextLevel?.displayAmount)),
                            },
                        })}
                    </Text>
                );
            }

            return text;
        }

        // 比较门槛，先凑门槛低的
        if (nextShippingCoupon && nextShippingCoupon.threshold.amount < (nextProductCoupon?.threshold?.amount ?? Infinity)) {
            logShowShippingCoupon(false, shippingAmountToNextLevel?.amount);
            // 还差X可享包邮
            return k18nPro({
                text: '再加{more_items}可享{benefits}',
                params: {
                    more_items: getBoldText(shippingAmountToNextLevel?.displayAmount),
                    benefits: getHighlightText(getFreeShippingText()),
                },
            });
        }

        // 凑商品券
        if (nextProductCoupon) {
            logShowProductCoupon(false, productAmountToNextLevel?.amount);
            // 已经凑成了低门槛的
            if (currentProductCoupon) {
                return k18nPro({
                    text: '已享{X_OFF}，再加{more_items}可再享{benefits}',
                    params: {
                        X_OFF: getBoldText(getProductDiscountText(currentProductCoupon.deductAmount?.displayAmount)),
                        more_items: getBoldText(productAmountToNextLevel?.displayAmount),
                        benefits: getHighlightText(getProductDiscountText(productMoreDeductOfNextLevel?.displayAmount)),
                    },
                });
            }

            // 凑第一张商品券
            // 还差{num}可享{discount}优惠券
            return k18nPro({
                // id: 'more_item_more_benefits',
                text: '再加{more_items}可享{benefits}',
                params: {
                    more_items: getBoldText(productAmountToNextLevel?.displayAmount),
                    benefits: getHighlightText(getProductDiscountText(productMoreDeductOfNextLevel?.displayAmount)),
                },
            });
        }

        if (!currentShippingCoupon && !nextShippingCoupon && !currentProductCoupon && !nextProductCoupon && totalPriceNumber <= 50) {
            return $k18n({
                text: '加购更多享惊喜',
                id: 'add_more_surprise',
            });
        }

        return k18nPro({
            text: '快领取商品券，享更多优惠！',
            id: 'k_400032',
        });
    }, [storeCartItem, storeCartItem?.cartShopList, selectedCartItemList?.length]);

    const openCart = () => {
        setCheckoutDetailPopupVisible(false);
        setVisiblePopCart(!visiblePopCart);
        if (!visiblePopCart) {
            // 为了让弹框看起来更快 先弹窗 后调接口
            setTimeout(() => {
                // fetchStoreCartItem();
                useShopInfoStore.getState().fetchStoreCartItem();
            }, 200);
            logger.sendShow({
                action: 'HALF_ADD_PRODUCTS',
                params: {
                    is_null: !selectedCartItemList?.length,
                },
            });
        }
    };

    const onOpenCheckoutDetail = () => {
        // debuggerName: '凑单工具条-折扣信息-点击',
        logger.sendClick({
            action: 'MONEY',
        });
        setVisiblePopCart(false);
        setCheckoutDetailPopupVisible(!checkoutDetailPopupVisible);
    };

    const onThrottledOpenCart = useCallback(
        debounce(() => {
            openCart();
            // debuggerName: '凑单工具条-购物袋图标-点击',
            logger.sendClick({
                action: 'SHOPPING_BAG',
                params: {
                    product_num: selectedCartItemList?.length,
                },
            });
        }, 20),
        [openCart],
    );

    const handleClickCart = () => {
        logger.sendClick({
            action: 'CART_ENTER',
        });
        logger.sendClick({
            action: 'GO_TO_CART_BUTTON',
            params: {
                // 所属区域类型；0-全部商品；1-多件多折专区
                area_type: 0,
            },
        });
        logger.sendClick({
            action: 'CART_ENTER',
        });
        const url = getMyShoppingCarUrl();
        openUrl({ url });
    };

    const totalPrice = () => {
        if (selectedInsufficient) {
            return `${webCurrency}-`;
        }
        if (!selectedCartItemList?.length) {
            return `${webCurrency}0,00`;
        }
        return shopDiscount?.itemCouponDiscount?.now?.displayAmount ?? `${webCurrency}0,00`;
    };

    // key 为凑单券的个数，数组中值为进度条上对号的位置
    const milestones = {
        0: [100],
        1: [100],
        2: [60, 100],
        3: [50, 80, 100],
    };

    // 店铺凑单加强进度条百分比
    const percentageV2 = useMemo(() => {
        // 没选中
        const isNoSelected = selectedCartItemList?.length === 0;
        if (isNoSelected) {
            return 0;
        }
        // 运费凑单券，运费只凑一张
        const { currentLevel: currentShippingCoupon, nextLevel: nextShippingCoupon } =
            storeCartItem?.cartShopList[0]?.shopEvaluate?.shopEvaluateCoupon?.shippingMakeupCoupons || {};
        // 商品凑单券
        const { currentLevel: currentProductCoupon, nextLevel: nextProductCoupon } =
            storeCartItem?.cartShopList[0]?.shopEvaluate?.shopEvaluateCoupon?.itemMakeupCoupons || {};
        // 没有券
        const noCoupon = !currentShippingCoupon && !nextShippingCoupon && !currentProductCoupon && !nextProductCoupon;
        const { totalStage = 1, currentStage = 0, progress = 0 } = storeCartItem?.cartShopList[0]?.thresholdStage || {};

        // 全商家包邮 而且没有其他券
        if (!isNoSelected && totalStage === 0 && storeCartItem?.selectedAllMerchantFreeShip) {
            logShowProgress({
                ratio: 100,
                currentStage,
                totalStage,
            });
            return 100;
        }

        if (isNoSelected || noCoupon || selectedInsufficient) {
            logShowProgress({
                ratio: 0,
                abnormalType: selectedInsufficient ? 0 : undefined,
                currentStage,
                totalStage,
            });
            return 0;
        }

        const milestone = milestones[totalStage];
        // 已达成阶段的百分比
        const basePercentage = milestone?.[currentStage - 1] ?? 0;
        // 当前阶段的百分比
        const curStagePercentage = (milestone?.[currentStage] ?? 100) - (milestone?.[currentStage - 1] ?? 0);
        logShowProgress({
            ratio: progress,
            currentStage,
            totalStage,
        });

        // alert(Math.min(basePercentage + (curStagePercentage * progress) / 100, 100));

        return Math.min(basePercentage + (curStagePercentage * progress) / 100, 100);
    }, [storeCartItem, storeCartItem?.cartShopList[0], storeCartItem?.cartShopList[0]?.thresholdStage, selectedInsufficient, selectedCartItemList]);

    const bottomNode = (
        <KView
            style={{
                paddingRight: 19,
                paddingLeft: 19,
                paddingTop: 16,
                paddingBottom: 16,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#fff',
                // backgroundColor: 'blue'
            }}
        >
            <KView style={{ marginRight: 16 }}>
                <KView>
                    <LogShow
                        action="SHOPPING_BAG"
                        params={{
                            product_num: selectedCartItemList?.length,
                        }}
                    >
                        <TouchableWithoutFeedback onPress={() => onThrottledOpenCart()}>
                            <KView>
                                <KImage style={{ width: 40, height: 40 }} source={MerchantBagIcon} />
                                {selectedCartItemList?.length > 0 ? (
                                    <KView
                                        style={styles({
                                            top: -1,
                                            // right: 8,
                                            right: Number(selectedCartItemList?.length) < 10 ? 7 : 2,
                                            position: 'absolute',
                                            transform: [{ translateX: 8 }],
                                        })}
                                    >
                                        <KView
                                            style={[
                                                {
                                                    backgroundColor: '#f00',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    borderRadius: 20,
                                                    top: 0,
                                                    right: 0,
                                                    overflow: 'hidden',
                                                },
                                                Number(selectedCartItemList?.length) < 10
                                                    ? {
                                                          width: 14,
                                                          height: 14,
                                                          borderRadius: 7,
                                                          textAlign: 'center',
                                                          display: 'flex',
                                                          flexDirection: 'row',
                                                          justifyContent: 'center',
                                                          alignItems: 'center',
                                                      }
                                                    : {
                                                          height: 14,
                                                          textAlign: 'center',
                                                          display: 'flex',
                                                          flexDirection: 'row',
                                                          justifyContent: 'center',
                                                          alignItems: 'center',
                                                          paddingLeft: 5,
                                                          paddingRight: 5,
                                                      },
                                            ]}
                                        >
                                            <KText rtlClassName={'right-cart-red-dot-text'} style={{ fontSize: 9, fontWeight: '700' }}>
                                                {selectedCartItemList?.length > 99 ? '99+' : selectedCartItemList?.length}
                                            </KText>
                                        </KView>
                                    </KView>
                                ) : null}
                            </KView>
                        </TouchableWithoutFeedback>
                    </LogShow>
                </KView>
            </KView>

            <KView style={{ flex: 1 }}>
                <KView>
                    <KView style={{ width: '100%' }}>
                        {/* 需要通过 ABmerchantAddonOptimize?.showProgressOptimize 来控制是否展示动画 等涛峰组件库更新 */}
                        {ABmerchantAddonOptimize?.showProgressOptimize ? (
                            <Progress
                                percentage={percentageV2}
                                pivotNode={null}
                                milestone={milestones[storeCartItem?.cartShopList[0]?.thresholdStage?.totalStage]}
                            />
                        ) : (
                            <Progress percentage={percentage} pivotNode={null} milestone={[100]} />
                        )}
                    </KView>
                    <KView style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', flexWrap: 'wrap', marginTop: 10 }}>
                        <Text
                            style={styles({
                                fontSize: shopDiscount?.itemCouponDiscount?.now?.displayAmount?.length > 10 ? 12 : 16,
                                fontWeight: '700',
                                color: '#000',
                                marginRight: 4,
                            })}
                        >
                            {totalPrice()}
                        </Text>
                        {vIf(
                            [!!shopDiscount?.itemTotalDiscount?.amount && !selectedInsufficient],
                            <TouchableOpacity activeOpacity={0.6} onPress={() => onOpenCheckoutDetail()}>
                                <LogShow action="MONEY">
                                    <Flex flex={'flexRowCenter'}>
                                        <Text style={[styles({ fontSize: 12 }), style.textRed]}>
                                            {$k18n({
                                                text: '{discount} OFF',
                                                params: { discount: shopDiscount?.itemTotalDiscount?.displayAmount },
                                            })}
                                        </Text>
                                        <Image
                                            style={
                                                styles({
                                                    width: 14,
                                                    height: 14,
                                                    transform: [{ rotate: checkoutDetailPopupVisible ? '90deg' : '-90deg' }],
                                                }) as ImageStyle
                                            }
                                            source={IconArrowRed}
                                        />
                                    </Flex>
                                </LogShow>
                            </TouchableOpacity>,
                        )}
                    </KView>
                </KView>
            </KView>

            <LogShow
                action="GO_TO_CART_BUTTON"
                params={{
                    // 所属区域类型；0-全部商品；1-多件多折专区
                    area_type: 0,
                }}
            >
                <KView style={{ marginLeft: 23 }}>
                    <Button size="small" type="primary" allowPress={true} onPress={handleClickCart}>
                        {$k18n({ id: 'k_379985', text: '去购物车' })}
                    </Button>
                </KView>
            </LogShow>
        </KView>
    );

    const emptyDiscountText = useMemo(() => {
        const shopPromotion = storeCartItem?.cartShopList[0]?.shopPromotion;
        const nextShippingCoupon = shopPromotion?.shippingAvailableCouponsList?.[0];
        const nextProductCoupon = shopPromotion?.itemAvailableCouponsList?.[0];
        const shippingThreshold = nextShippingCoupon?.threshold?.amount;
        const productThreshold = nextProductCoupon?.threshold?.amount;

        // 测试文案 用于调试多字数
        // return 'Receba cupons de produto e aproveite mais descontos!';

        if (!nextShippingCoupon && !nextProductCoupon) {
            return $k18n({
                text: '快领取商品券，享更多优惠！',
                id: 'k_400032',
            });
        }

        // 如果同时拥有商品券和运费券
        if (nextShippingCoupon && nextProductCoupon) {
            // 门槛相同时，同时展示两个优惠
            if (shippingThreshold === productThreshold) {
                return k18nPro({
                    id: 'enjoy_a_and_b',
                    params: {
                        free_shipping: getHighlightText(getFreeShippingText(), false),
                        X_OFF: getHighlightText(getProductDiscountText(nextProductCoupon?.maxDeductAmount?.displayAmount), false),
                    },
                });
            }

            if (shippingThreshold < productThreshold) {
                return k18nPro({
                    id: 'enjoy_sth',
                    params: {
                        benefits: getHighlightText(getFreeShippingText(), false),
                    },
                });
            }

            return k18nPro({
                id: 'enjoy_sth',
                params: {
                    benefits: getHighlightText(getProductDiscountText(nextProductCoupon?.maxDeductAmount?.displayAmount), false),
                },
            });
        }

        if (nextShippingCoupon) {
            return k18nPro({
                id: 'enjoy_sth',
                params: {
                    benefits: getHighlightText(getFreeShippingText(), false),
                },
            });
        }

        return k18nPro({
            id: 'enjoy_sth',
            params: {
                benefits: getHighlightText(getProductDiscountText(nextProductCoupon?.maxDeductAmount?.displayAmount), false),
            },
        });
    }, [storeCartItem, storeCartItem?.cartShopList[0]]);

    const bottomNode2 = (
        <KView
            style={{
                paddingRight: 19,
                paddingLeft: 19,
                paddingTop: 13,
                paddingBottom: 16,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                backgroundColor: '#fff',
                alignItems: 'center',
            }}
        >
            <KView style={{ marginRight: 16, flex: 1 }}>
                <KView>
                    <LogShow
                        action="SHOPPING_BAG"
                        params={{
                            product_num: selectedCartItemList?.length,
                        }}
                    >
                        <KView>
                            <KView style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Text style={{ color: '#000000', fontSize: 14, fontWeight: '400' }}>{$k18n({ id: 'tap' })}</Text>
                                <Image source={iconAddCart} style={{ width: 24, height: 24, marginLeft: 4, marginRight: 4 }} resizeMethod="resize" />
                                <Text style={{ color: '#000000', fontSize: 14, fontWeight: '400' }}>{$k18n({ id: 'add_product' })}</Text>
                            </KView>

                            <KView>
                                <Text
                                    style={{ color: '#000000', maxWidth: 260, fontSize: emptyDiscountText?.length > 30 ? 9 : 14, fontWeight: '400' }}
                                >
                                    {emptyDiscountText}
                                </Text>
                            </KView>
                        </KView>
                    </LogShow>
                </KView>
            </KView>

            <LogShow
                action="GO_TO_CART_BUTTON"
                params={{
                    // 所属区域类型；0-全部商品；1-多件多折专区
                    area_type: 0,
                }}
            >
                <KView>
                    <Button size="small" type="primary" allowPress={true} textStyle={{ fontWeight: '500' }} onPress={handleClickCart}>
                        {$k18n({ id: 'k_379985', text: '去购物车' })}
                        {/* {'Ir ao Carrinho'} */}
                    </Button>
                </KView>
            </LogShow>
        </KView>
    );

    const styleLine = {
        flexDirection: 'row',
        height: '100%',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 14,
        lineHeight: 21,
        color: 'rgba(0, 0, 0, 0.88)',
        backgroundColor: '#fff',
        paddingLeft: 19,
        paddingRight: 19,
    };

    const bottomViewOld = (
        <KView
            style={styles({
                height: bottomNodeHeight,
                zIndex: 60,
                flexShrink: 0,
                backgroundColor: '#ffffff',
                // marginBottom: marginBottomForNode,
                // box-shadow: 0 6px #fff, 0 -1px 6px 0 rgba(0, 0, 0, 0.06);
                shadowColor: 'rgba(0, 0, 0, 0.06)',
                // elevation: 5, // 这个属性不能加， 加了后层级太高 盖住了别的模块 原因未知
                // shadowOffset: {
                //     width: 20,
                //     height: 20,
                // },
                // shadowOpacity: 0.25,
                // shadowRadius: 3.84,
            })}
        >
            <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 0, y: 1 }} colors={['rgba(255, 73, 6, 0.08)', 'rgba(255, 73, 6, 0)']} style={styleLine}>
                {/* <KView
                    style={styles({
                        paddingLeft: 19,
                        paddingRight: 19,
                        height: 37,
                        backgroundColor: '#fff6f3', // todo react native 怎么背景色渐变
                        // backgroundColor: 'linear-gradient(180deg, rgba(255, 73, 6, 0.08) 0%, rgba(255, 73, 6, 0) 100%)',
                    })}
                > */}
                <TextSwipper>
                    <KText rtlClassName="TextSwipperStyle">{discountText}</KText>
                </TextSwipper>
                {/* </KView> */}
            </LinearGradient>
            {bottomNode}
        </KView>
    );

    const bottomViewNew = (
        <KView
            style={styles({
                height: bottomNodeHeight - 37,
                zIndex: 60,
                flexShrink: 0,
                backgroundColor: '#f2f2f2',
            })}
        >
            {bottomNode2}
        </KView>
    );

    // 购物袋为空 并且 命中实验
    return ABmerchantAddonOptimize?.showEmptyAddonBar && productList?.length === 0 ? bottomViewNew : bottomViewOld;
}
